import { HttpClient } from './HttpClient';

export function requireSuccess(response) {
  if (response.error || response.message || response.errors) {
    const detail = response.errors || response.msg || response.message;
    throw new Error(typeof detail === 'string' ? detail : Object.values(detail || {}).flat().join(' '));
  }
  return response.response;
}
export const DespachoCatalogService = {
  list: () => HttpClient.get('/despachos').then(requireSuccess),
  create: data => HttpClient.postJSON('/despachos', data).then(requireSuccess),
  update: (id, data) => HttpClient.putJSON(`/despachos/${id}`, data).then(requireSuccess),
  catalogs: id => HttpClient.get(`/despachos/${id}/catalogs`).then(requireSuccess),
  settings: (id, data) => HttpClient.putJSON(`/despachos/${id}/catalog-settings`, data).then(requireSuccess),
  entry: (id, kind, entryId, data) => (entryId
    ? HttpClient.putJSON(`/despachos/${id}/catalogs/${kind}/${entryId}`, data)
    : HttpClient.postJSON(`/despachos/${id}/catalogs/${kind}`, data)).then(requireSuccess),
  remove: (id, kind, entryId, revision) => HttpClient.postJSON(`/despachos/${id}/catalogs/${kind}/${entryId}/remove`, { revision }).then(requireSuccess),
  management: () => HttpClient.get('/management/catalog-config').then(requireSuccess),
};
